import React, { useState, useEffect, useRef } from 'react';
import Header from "../../../../Components/Header/Header.js";
import LeftMenu from '../../../../Components/LeftMenu/LeftMenu.js';
import TopMenu from '../../../../Components/TopMenu/TopMenu.js';

import 'jqwidgets-framework/jqwidgets/jqxcore';
import 'jqwidgets-framework/jqwidgets/jqxdata';
import 'jqwidgets-framework/jqwidgets/jqxbuttons';
import 'jqwidgets-framework/jqwidgets/jqxscrollbar';
import 'jqwidgets-framework/jqwidgets/jqxmenu';
import 'jqwidgets-framework/jqwidgets/jqxgrid';
import 'jqwidgets-framework/jqwidgets/jqxgrid.pager';
import 'jqwidgets-framework/jqwidgets/jqxgrid.sort';
import 'jqwidgets-framework/jqwidgets/jqxgrid.edit';
import 'jqwidgets-framework/jqwidgets/jqxgrid.filter';
import 'jqwidgets-framework/jqwidgets/jqxgrid.selection';
import 'jqwidgets-framework/jqwidgets/jqxgrid.columnsresize';
import 'jqwidgets-framework/jqwidgets/styles/jqx.base.css';
import 'jqwidgets-framework/jqwidgets/styles/jqx.dark.css';
import $ from 'jqwidgets-framework/jqwidgets/jqx-all';
import 'jqwidgets-framework/jqwidgets/jqxgrid.export';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Container, Row, Col, Modal, Button, Tab, Tabs } from 'react-bootstrap';
import { faPlus, faXmark, faCircle, faPaperclip, faBolt, faCircleXmark, faLink, faCircleCheck, faChevronDown, faGear } from '@fortawesome/free-solid-svg-icons';
// import Slider from "react-slick";
import { Link } from 'react-router-dom';
import 'jqwidgets-framework/jqwidgets/jqxgrid.export';

import Arcv from "../../../../assets/images/archive.svg";
// import { MultiSelect } from 'react-multi-select-component';
// import Dropdown from 'react-bootstrap/Dropdown';
// import Docmnt from '../../../assets/images/google-docs.png';
// import Arcv from "../../../assets/images/archive.svg";
// import Activ from "../../../assets/images/active.svg";
import Export from "../../../../assets/images/export.svg";
import edit from "../../../../assets/images/edit.png";
import Trash from '../../../../assets/images/trash.png';
import Cargoplane from "../../../../assets/images/plane.svg";
// import Cuser from "../../../assets/images/cuser.png";
// import { CKEditor } from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Badge from 'react-bootstrap/Badge';
import ImageUpload from '../../../../Components/common/ImageUpload';
import ActivityComments from '../../../../Components/common/ActivityComments';
import DownloadGrid from '../components/DownloadGrid.js';
import { toast } from 'react-toastify';

import { withoutRFSToken, withRFSToken } from '../../../../Services/axios.js';
import { ULDASSETSGRID, GETDAMAGETYPE, UPDATESTATUS, UPDATECONDITION, GETULDDETAILS, MOVETOACTARC, DOWNLOADULD, GETTYPECODE, GETDESTINATION, GETCONDITIONCODE, GETOWNERCODE, MVTHDETAILS, RECMISSING } from '../../../../Utils/conts.js';
import { jqxCookieCall } from '../../../../Components/common/CommonFunctions.js';

const FlightSchedule = () => {

    const [gridData, setGridData] = useState({
        Active: [],
        Archived: [],
        // Trash: []

    });
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const isMounted = useRef(false);
    const [damageType, setDamageType] = useState([]);
    const [totalRows, setTotalRows] = useState({});
    const [totalRowsR, setTotalRowsR] = useState(0);
    const [filterApplied, setFilterApplied] = useState(false);

    const fetchDataGrid = async (pageNumber, psize) => {
        const page_number = pageNumber ? pageNumber : 1;
        const pageSize = psize ? psize : 20;
        setIsLoading(true);
        const tabName = activeTab == 'Active' ? 'A' : 'R';
        try {
            const res = await withRFSToken.post(ULDASSETSGRID, { page: page_number, type: tabName, page_size: pageSize })
            // .then(function (res) {
            if (res.data.response_code == 200) {
                setIsLoading(false);
                const innerData = res.data.response_data.ulds;
                // console.log("🚀 ~ .then ~ innerData:654", innerData)
                // const transformData = innerData ? innerData.map(data => ({ ...data, reg: 'R' })) : '';
                setGridData({ Active: innerData });
                setTotalRows({
                    pageSize: res.data.response_data.page_size,
                    currPage: res.data.response_data.current_page,
                    lastPage: res.data.response_data.last_page,
                    totalUlds: res.data.response_data.total_ulds
                });
                setTotalRowsR({
                    totalUlds: res.data.response_data.archive_count
                });
                // window.$(gridRefs[activeTab].current).jqxGrid('pagesize', res.data.response_data.page_size);
            }
            // });
        } catch (error) {
            console.error('Error fetching data:', error);
            // setIsLoading(false);
        }
    };
    const fetchDataGridR = async (pageNumber, psize) => {
        const page_number = pageNumber ? pageNumber : 1;
        const pageSize = psize ? psize : 20;
        setIsLoading(true);
        try {
            const res = await withRFSToken.post(ULDASSETSGRID, { page: page_number, type: 'R', page_size: pageSize });
            setIsLoading(false);
            // .then(function (res) {
            if (res.data.response_code == 200) {
                const innerData = res.data.response_data.ulds;
                // console.log("🚀 ~ .then ~ innerData:654", innerData)
                // const transformData = innerData ? innerData.map(data => ({ ...data, reg: 'R' })) : '';
                setGridData({ Archived: innerData });
                setTotalRowsR({
                    pageSize: res.data.response_data.page_size,
                    currPage: res.data.response_data.current_page,
                    lastPage: res.data.response_data.last_page,
                    totalUlds: res.data.response_data.total_ulds
                });
                // });
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            // setIsLoading(false);
        }
    };

    useEffect(() => {
        if (isMounted.current) return;
        // Call the fetchData function to fetch data from the API
        // fetchDataGrid();
        setIsLoading(false);
        setGridData({ Active: {} });
        // fetchDataGridR();
        isMounted.current = true;
    }, []);
    const fetchDamageType = async () => {
        try {
            const res = await withRFSToken.post(GETDAMAGETYPE, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // console.log("🚀 ~ .then ~ innerData:654", innerData)
                    setDamageType(innerData);
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    const [selectedRowData, setSelectedRowData] = useState(null);
    const [selectedRowDetails, setSelectedRowDetails] = useState(null);
    const [gridSelect, setGridSelect] = useState([]);
    const [activeTab, setActiveTab] = useState('Active');

    const gridRefs = {
        Active: useRef(null),
        Archived: useRef(null),
    };
    const handleTabChange = async (tab) => {
        setActiveTab(tab);
        // const tabType = () => {tab == 'Active' ? 'A' : 'R'}
        setFilterApplied(false);
        if (selectedRowData) {
            setSelectedRowData(null)
        }
        setGridSelect([]);
        setIsLoading(true);
        if (tab == 'Active') {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Active: {} });
            }, 1);
        } else {
            setTimeout(() => {
                setIsLoading(false);
                setGridData({ Archived: {} });
            }, 1);
        }
        // let tabType = '';
        // if (tab == 'Active') { tabType = 'A' } else { tabType = 'R' }
        // if (tab == 'Active') { fetchDataGrid() } else { fetchDataGridR() }
        // setIsLoading(true);
        // try {
        //     const res = await withRFSToken.post(ULDASSETSGRID, { type: tabType });
        //     setIsLoading(false);
        //     // .then(function (res) {
        //     if (res.data.response_code == 200) {
        //         const innerData = res.data.response_data.ulds;
        //         // console.log("🚀 ~ .then ~ innerData:654", innerData)
        //         // const transformData = innerData ? innerData.map(data => ({...data, reg: 'R' })) : '';
        //         if (tabType == 'A') {
        //             // const transformData = innerData ? innerData.map(data => ({ ...data, reg: 'R' })) : '';
        //             setGridData({ Active: innerData });
        //             // setTotalRows(res.data.response_data.total_ulds);
        //             setTotalRows({
        //                 pageSize: res.data.response_data.page_size,
        //                 currPage: res.data.response_data.current_page,
        //                 lastPage: res.data.response_data.last_page,
        //                 totalUlds: res.data.response_data.total_ulds
        //             });
        //         } else {
        //             // const transformData = innerData ? innerData.map(data => ({ ...data, reg: 'N' })) : '';
        //             setGridData({ Archived: innerData });
        //             setTotalRowsR(res.data.response_data.total_ulds);
        //         }
        //         // });
        //     }
        // } catch (error) {
        //     console.error('Error fetching data:', error);
        // }
    };
    const [cellEdit, setCellEdit] = useState(false);
    const [cellEditData, setCellEditData] = useState({});
    // Edit Uld
    const [showEdit, setShowEdit] = useState(false);
    const [editData, setEditData] = useState({});
    const handleCloseEditModal = () => {
        setShowEdit(false);
        setEditData({});
    };

    // const gridSelectRef = useRef(gridSelect); // Create a ref for gridSelect

    // useEffect(() => {
    //     gridSelectRef.current = gridSelect; // Update the ref with the latest gridSelect value
    // }, [gridSelect]);
    let checkUlds = [];
    let filterForCheck = false;
    useEffect(() => {
        if (gridRefs[activeTab]?.current) {
            // var token = "Bearer " + localStorage.ULD;
            jqxCookieCall()
            let tabType = '';
            if (activeTab == 'Active') { tabType = 'A' } else { tabType = 'R' }
            const source = {
                datatype: 'json',
                datafields: [
                    { name: 'id', type: 'string' },
                    { name: 'flight_no', type: 'string' },
                    { name: 'flight_date', type: 'date' },
                    { name: 'origin', type: 'string' },
                    { name: 'departure_time_utc', type: 'string' },
                    { name: 'departure_time_local', type: 'string' },
                    { name: 'destination', type: 'string' },
                    { name: 'arrival_time_utc', type: 'string' },
                    { name: 'arrival_time_local', type: 'string' },
                    { name: 'aircraft_type', type: 'string' },
                    { name: 'day_of_week', type: 'string' },
                    { name: 'created_at', type: 'date' },

                ],
                id: `${activeTab}-`,
                url: `${process.env.REACT_APP_RFS_URL}flight-schedule/get-list?tab=${tabType}`,
                // beforeSend: function (jqXHR) {
                //     jqXHR.setRequestHeader('Authorization', token);
                // },
                pagesize: 50,
                filter: function (allfilters) {
                    if (allfilters.length > 0) {
                        setFilterApplied(true);
                        filterForCheck = true;
                    } else {
                        setFilterApplied(false);
                        filterForCheck = false;
                    }
                    window.$(gridRefs[activeTab].current).jqxGrid('clearselection');
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "filter");


                    // setTimeout(() => {
                    //     const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');

                    //     console.log("rows", rows);
                    //     (checkUlds).forEach(uldNumber => {
                    //         console.log(checkUlds);
                    //         rows.forEach((element, index) => {
                    //             if (element.uld_number == uldNumber) {
                    //                 window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
                    //             }
                    //         });
                    //     });
                    // }, 4000);
                },
                beforeprocessing: function (data) {
                    source.totalrecords = data.TotalRows;
                    setTotalRows({ totalUlds: data.activeCount });
                    setTotalRowsR({ totalUlds: data.archiveCount });
                },
                sort: function () {
                    window.$(gridRefs[activeTab].current).jqxGrid("updatebounddata", "sort");
                },
                root: "Rows",
                cache: false,
            };
            const dataAdapter = new window.$.jqx.dataAdapter(source);
            const columns = [
                {
                    text: 'Actions',
                    cellsrenderer: function () {
                        return '<div class="grid_actions"><img src="' + edit + '" class="row_edit" /> <img src="' + Trash + '" class="row_trash" /></div>';
                    },
                    width: '5%', filterable: false,
                },
                { text: 'Flight No', filtertype: 'textbox', datafield: 'flight_no', width: '6%', cellclassname: '', },
                { text: 'Flight Date', filtertype: 'range', cellsformat: 'dd-MM-yyyy', filtermode: 'range', datafield: 'flight_date', width: '7%', cellclassname: '', },
                { text: 'Origin', filtertype: 'textbox', datafield: 'origin', width: '6%', cellclassname: '', },
                {
                    text: 'Departure Time UTC', filtertype: 'textbox', datafield: 'departure_time_utc', width: '10%', cellclassname: '',
                    cellsrenderer: (row, column, value) => {
                        if (value && value.length === 4) {
                            return `<div style="margin-left:10px;line-height: 41px;color: #2b2f36 !important;font-family: Roboto, sans-serif !important;font-size: 14px;">${value.slice(0, 2)}:${value.slice(2)}</div>`;
                        }
                        return `<div style="margin-left:10px;line-height: 41px;color: #2b2f36 !important;font-family: Roboto, sans-serif !important;font-size: 14px;">${value}</div>`;
                    }
                },
                { text: 'Departure Time Local', filtertype: 'textbox', datafield: 'departure_time_local', width: '8%', cellclassname: '', },
                { text: 'Destination', filtertype: 'textbox', datafield: 'destination', width: '8%', cellclassname: '', },
                {
                    text: 'Arrival Time UTC', filtertype: 'textbox', datafield: 'arrival_time_utc', width: '8%', cellclassname: '',
                    cellsrenderer: (row, column, value) => {
                        if (value && value.length === 4) {
                            return `<div style="margin-left:10px;line-height: 41px;color: #2b2f36 !important;font-family: Roboto, sans-serif !important;font-size: 14px;">${value.slice(0, 2)}:${value.slice(2)}</div>`;
                        }
                        return `<div style="margin-left:10px;line-height: 41px;color: #2b2f36 !important;font-family: Roboto, sans-serif !important;font-size: 14px;">${value}</div>`;
                    }
                },
                { text: 'Arrival Time Local', filtertype: 'textbox', datafield: 'arrival_time_local', width: '8%', cellclassname: '', },
                { text: 'Aircraft Type', filtertype: 'textbox', datafield: 'aircraft_type', width: '10%', cellclassname: '', },
                { text: 'Day of Week', filtertype: 'textbox', datafield: 'day_of_week', width: '6%', cellclassname: '', },
                { text: 'Updated On', filtertype: 'range', cellsformat: 'dd-MM-yyyy', filtermode: 'range', datafield: 'created_at', width: '8%', cellclassname: '', },
            ];
            const gridOptions = {
                width: '100%',
                source: dataAdapter,
                columns: columns,
                autoheight: false,
                height: 1040,
                sortable: true,
                altrows: false,
                columnsresize: false,
                enabletooltips: false,
                editable: false,
                selectionmode: 'checkbox',
                pageable: true,
                pageSize: 50,
                pagesizeoptions: ['50', '100', '200', '500'],
                pagerButtonsCount: 5,
                pagerMode: 'advanced',
                filterable: true,
                filterrowheight: 45,
                showfilterrow: true,
                rowsheight: 42,
                columnsheight: 45,
                showstatusbar: true,
                virtualmode: true,
                rendergridrows: function (params) {
                    return params.data;
                },
                rendered: function () {
                    const rows = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                    (checkUlds).forEach(uldNumber => {
                        rows.forEach((element, index) => {
                            if (element.uld_number == uldNumber) {
                                window.$(gridRefs[activeTab].current).jqxGrid('selectrow', index);
                            }
                        });
                    });
                }
            };
            window.$(gridRefs[activeTab].current).jqxGrid(gridOptions);
            window.$(gridRefs[activeTab].current).find('.jqx-grid-column-header').css('background-color', 'white');

            window.$(gridRefs[activeTab].current).on('click', '.row_edit', function () {
                localStorage.removeItem('EditFlight')
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    // console.log('Global Index:', globalIndex); 
                    const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
                    loadDetails(rowData.id, 'E');

                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }
                // const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);

            });
            window.$(gridRefs[activeTab].current).on('click', '.row_trash', function () {
                localStorage.removeItem('EditFlight')
                const rowDiv = window.$(this).closest('[role="row"]');
                const rowIndex = window.$(rowDiv).attr('row-id');
                const boundIndex = window.$(gridRefs[activeTab].current).jqxGrid('getrowid', rowIndex);

                if (boundIndex !== undefined) {
                    const pagingInfo = window.$(gridRefs[activeTab].current).jqxGrid('getpaginginformation');
                    const pageIndex = pagingInfo.pagenum;
                    const pageSize = pagingInfo.pagesize;
                    const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
                    // console.log('Global Index:', globalIndex); 
                    const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', globalIndex);
                    setShowConfirm(true);
                    setDeleteId(rowData.id);

                } else {
                    console.error('Bound index could not be retrieved. Check the row index and data binding.');
                }
                // const rowData = window.$(gridRefs[activeTab].current).jqxGrid('getrowdata', rowIndex);

            });
            window.$(gridRefs[activeTab].current).find('div[role="row"]').each((index, row) => {
                window.$(row).on('mouseover', () => {
                    window.$(row).addClass('row-hover');
                });
                window.$(row).on('mouseout', () => {
                    window.$(row).removeClass('row-hover');
                });
            });
            window.$(gridRefs[activeTab].current).on('rowselect', (event) => {
                if (event.args.row) {
                    const selectedRow = event.args.row;
                    const uldNumber = selectedRow.uld_number;
                    const selectedRowId = selectedRow.uid;
                    if (!checkUlds.includes(uldNumber)) {
                        checkUlds.push(uldNumber);
                    }
                    // console.log(checkUlds);
                    // if (!gridSelect.some(row => row.uld_number === uldNumber)) {
                    //     setGridSelect(prevGridSelect => Array.from(new Set([...prevGridSelect, selectedRow])));
                    // }
                    setGridSelect(prevGridSelect => {
                        if (!prevGridSelect.some(row => row.uld_number === uldNumber)) {
                            return [...prevGridSelect, selectedRow];
                        }
                        return prevGridSelect;
                    });
                } else {
                    if (event.args.rowindex.length > 0) {
                        const allIds = window.$(gridRefs[activeTab].current).jqxGrid('getrows');
                        setGridSelect(allIds);
                    } else {
                        setGridSelect([]);
                    }
                }
            });
            window.$(gridRefs[activeTab].current).on('rowunselect', (event) => {
                if (event.args.row) {
                    const unselectedRowId = event.args.row.uld_number;
                    setGridSelect(prevSelection => prevSelection.filter(row => row.uld_number !== unselectedRowId));
                    // if(filterForCheck!=true){
                    if (!checkUlds.includes(unselectedRowId)) {
                        checkUlds.push(unselectedRowId);
                    } else {
                        checkUlds = checkUlds.filter(item => item !== unselectedRowId);
                    }
                    // }
                    // console.log(checkUlds);

                }
            });
            window.$(gridRefs[activeTab].current).off('cellclick');
            window.$(gridRefs[activeTab].current).on('cellclick', (event) => {
                const args = event.args.row.bounddata;
                if (event.args.columnindex > 1) {
                    if (gridSelect) {
                        gridSelect.forEach(item => {
                            const selectedRowBoundIndex = item.boundindex;
                            window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
                        });
                    }
                    loadDetails(args.id, 'D');
                }
            });
        }
    }, [gridData]);

    const handleAddFlight = () => {
        localStorage.removeItem('EditFlight');
        window.location.href = '/FlightSchedule/AddFlight';
    }
    // START This is for irregular details open
    // useEffect(() => {
    //     const gridRef = gridRefs[activeTab].current;
    //     if (gridRef) {
    //         // Reinitialize or refresh grid data as necessary
    //         window.$(gridRef).jqxGrid('updatebounddata');
    //     }
    // }, [gridData]);
    // This is for irregular details open END
    // console.log('101', gridData);
    const loadDetails = async (uldNumber, pos) => {
        try {
            const res = await withRFSToken.get(`flight-schedule/details/${uldNumber}`, {})
                .then(function (res) {
                    const innerData = res.data.response_data;
                    // console.log("🚀 ~ .then ~ innerData:654", innerData)
                    if (pos === 'D') {
                        setSelectedRowData(innerData);
                        setTimeout(() => {
                            window.$(gridRefs[activeTab].current).jqxGrid('refresh');
                        }, 30);
                    } else if (pos === 'E') {

                        const transData = {
                            id: innerData.id,
                            flight_code: innerData.flight_code,
                            flight_number: innerData.flight_number,
                            flight_date: innerData.flight_date,
                            origin: innerData.origin,
                            destination: innerData.destination,
                            departure_time_utc: innerData.departure_time_utc.slice(0, 2) + ':' + innerData.departure_time_utc.slice(2),
                            arrival_time_utc: innerData.arrival_time_utc.slice(0, 2) + ':' + innerData.arrival_time_utc.slice(2),
                        }
                        localStorage.setItem('EditFlight', JSON.stringify(transData))
                        window.location.href = '/FlightSchedule/AddFlight'
                    }


                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }
    const handleCloseClick = () => {
        setSelectedRowData(null);
        setTimeout(() => {
            window.$(gridRefs[activeTab].current).jqxGrid('refresh');
        }, 30);
    };

    const [selectedColumns, setSelectedColumns] = useState([]);
    const [downloadOpen, setDownloadOpen] = useState(false);
    const showDownloadModal = () => {
        setDownloadOpen(true);
    };
    const closeDownloadModal = () => {
        setDownloadOpen(false);
    };

    const columnsToExport = {
        // uld_number: 'ULD Number',
        type_code: 'Type Code',
        // serial_number: 'Serial Number',
        owner_code: 'Owner Code',
        condition_code: 'Condition Code',
        status: 'Status',
        origin: 'Origin',
        destination: 'Destination',
        // scm: 'SCM',
        // scm_date: 'SCM Date',
        // asset_type: 'Asset Type',
        // handler_name: 'Handler Name',
        // airline_name: 'Airline Name',
        // Add more columns here if needed
    };
    const handleColumnChange = (columnKey) => {
        setSelectedColumns(prevSelected =>
            prevSelected.includes(columnKey)
                ? prevSelected.filter(key => key !== columnKey)
                : [...prevSelected, columnKey]
        );
    };

    // ++++++++++++++++++++++++++++++++++++++++++++ HTML EDITOR

    var settings = {
        dots: false,
        infinite: false,
        slidesToShow: 2,
        slidesToScroll: 1,

    };

    // +++++++++++++++++++++++++++++++++++ Silk Slider

    const [show, setShow] = useState(false);
    const [selectedFile, setSelectedFile] = useState('');

    const handleFileClick = (file) => {
        setSelectedFile(file);
        setShow(true);
    };

    const handleClose = () => {
        setShow(false);
        setSelectedFile('');
    };

    // ++++++++++++++++++++++++++++++++++++ Zoom Image


    // ++++++++++++++++++++++++++++++++++++ Zoom Image

    const [showConfirm, setShowConfirm] = useState(false);
    const [deleteId, setDeleteId] = useState('');

    const closeConfirm = () => {
        setShowConfirm(false);
    }
    const handleConfirmation = async (cnf) => {
        if (cnf) {
            console.log('2');
            try {
                const res = await withRFSToken.post(`flight-schedule/delete/${deleteId}`, {})
                    .then(function (res) {
                        const innerData = res.data.response_data;
                        toast.success(res.data.response_msg);
                        // console.log("🚀 ~ .then ~ innerData:654", innerData)
                        setShowConfirm(false);
                        setTimeout(() => {
                            setIsLoading(false);
                            window.$(gridRefs[activeTab].current).jqxGrid('updatebounddata')
                        }, 1);
                        // window.$(gridRefs[activeTab]).jqxGrid('updatebounddata')
                    });
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        } else {
            setShowConfirm(false);
        }

    }


    //   +++++++++ single select station +++++++
    let [selected, setSelected] = useState([]);
    if (selected.length > 1) {
        selected = selected.slice(1);
    }
    const options = [
        { id: '1', label: 'option1', value: 'option1' },
        { id: '1', label: 'option2', value: 'option2' },
        { id: '1', label: 'option3', value: 'option3' },
        { id: '1', label: 'option4', value: 'option4' },
    ];
    const handleSelectChange = (selected) => {
        setSelected(selected);
    };
    //   +++++++++ single select station +++++++

    // upload Section
    const [showModalUpload, setShowModalUpload] = useState(false);
    const [selectedRowId, setSelectedRowId] = useState(null);
    const [files, setFiles] = useState([]);
    const fileInputRef = useRef(null);
    const [base64Files, setBase64Files] = useState([]);

    // const imageModalUpload = (id) => {
    //     setSelectedRowId(id);
    //     setShowModalUpload(true)
    //     setFiles([])
    // }
    const imageModalUpload = (id) => {
        const selectedRowFiles = gridSelect.find(item => item.uid === id)?.files || [];
        setFiles(selectedRowFiles);
        setSelectedRowId(id); // Store the ID of the selected row
        setShowModalUpload(true);
    };
    const handleDrop = (e) => {
        e.preventDefault();
        const droppedFiles = Array.from(e.dataTransfer.files);
        setFiles((prevFiles) => [...prevFiles, ...droppedFiles]);
        getBase64(droppedFiles[0]);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
    };

    const handleDeleteFile = (index) => {
        setFiles((prevFiles) => {
            const newFiles = [...prevFiles];
            newFiles.splice(index, 1);
            return newFiles;
        });
        base64Files.splice(index, 1);
    };

    const handleBrowseFiles = (e) => {
        e.preventDefault();
        fileInputRef.current.click();
    };

    function getBase64(file) {
        var reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            setBase64Files((prevBase64Files) => [...prevBase64Files, reader.result]);
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

    const handleFileChange = (e) => {
        const selectedFiles = Array.from(e.target.files);
        const filesWithBase64 = [];

        selectedFiles.forEach((file) => {
            const reader = new FileReader();
            reader.onloadend = () => {
                filesWithBase64.push({ "base64": reader.result, "file_name": file.name });

                if (filesWithBase64.length === selectedFiles.length) {
                    setFiles((prevFiles) => [...prevFiles, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                    setBase64Files((prevBase64Files) => [...prevBase64Files, ...filesWithBase64.map((obj) => ({ base64: obj.base64, file_name: obj.file_name }))]);
                }
            };
            reader.readAsDataURL(file);
        });
    };
    const imageUpload = () => {
        setGridSelect(prevGridSelect =>
            prevGridSelect.map(item => {
                if (item.uid === selectedRowId) {
                    return { ...item, files: files, base64Files: base64Files };
                }
                return item;
            })
        );
        setShowModalUpload(false);
    };
    // upload forward
    const imageUploadRef = useRef(null);
    const browseClick = () => {
        if (imageUploadRef.current) {
            imageUploadRef.current.handleBrowseFiles();
        }
    };

    const handleDetailsClick = async (history) => {

        if (!selectedRowData) {
            throw new Error('Selected row data is not available.');
        }
        try {
            const res = await withRFSToken.post(MVTHDETAILS, { uld_id: selectedRowData.uld_id, uld_status_id: history.uld_status_id, group_id: history.group_id })
                .then(function (res) {
                    const innerData = res.data.response_data;
                    localStorage.removeItem('MHistory');
                    localStorage.removeItem('MHDetails');
                    const storageData = {
                        ULD: selectedRowData,  // ULD Details section
                        Form: {}  // Empty form section
                    };
                    localStorage.setItem('MHistory', JSON.stringify(storageData));
                    const storageDataDetails = {
                        ULD: innerData.others_ulds,  // ULD Details section
                        Form: innerData.uld_movement_detail,
                        tab: 'All'  // Empty form section
                    };
                    localStorage.setItem('MHDetails', JSON.stringify(storageDataDetails));
                    // localStorage.setItem('tab', 'operations');
                    let detailsPageUrl;
                    const detailsType = history.operation_type || history.ucm_inout || history.luc_inout || history.repair_inout || history.lease_inout || history.station;
                    if (detailsType) {

                        detailsPageUrl = '/ULDControl/MovementHistorydetails';
                        window.location.href = detailsPageUrl;
                    } else {
                        console.log('No valid details type found');
                    }
                });
        } catch (error) {
            console.error('Error fetching data:', error);
        }

        // localStorage.removeItem('MHistory');
        // localStorage.removeItem('MHDetails');
        // const storageData = {
        //     ULD: selectedRowData,  // ULD Details section
        //     Form: {}  // Empty form section
        // };
        // localStorage.setItem('MHistory', JSON.stringify(storageData));
        // const storageDataDetails = {
        //     ULD: history,  // ULD Details section
        //     tab: 'All'  // Empty form section
        // };
        // localStorage.setItem('MHDetails', JSON.stringify(storageDataDetails));
        // localStorage.setItem('tab', 'assets');
        // let detailsPageUrl;
        // const detailsType = history.operation_type || history.ucm_inout || history.luc_inout || history.repair_inout || history.lease_inout || history.station;
        // if (detailsType) {

        //     detailsPageUrl = '/ULDControl/MovementHistorydetais';
        //     window.location.href = detailsPageUrl;
        // } else {
        //     console.log('No valid details type found');
        // }

    };
    const resetFilters = () => {
        window.$(gridRefs[activeTab].current).jqxGrid('clearfilters');
        // gridSelect.forEach(item => {
        //     const selectedRowBoundIndex = item.boundindex;
        //     window.$(gridRefs[activeTab].current).jqxGrid('unselectrow', selectedRowBoundIndex);
        // });
        // setGridSelect([]);
    };


    return (
        <>
           {downloadOpen && <DownloadGrid download_area={activeTab} download_sec={'flsch'} onClose={closeDownloadModal} />}
            <div className="">
                <Header logo_url='/FlightSchedule' />
                <div className="page-body-wrapper schedule">
                    <LeftMenu />
                    <div className="main-panel rounded">
                        <div className="mainTab">
                            <TopMenu module='ULD' />
                            <div className="">
                                <div className="allcontent-fl">
                                    <div className='d-flex justify-content-between mb-3'>
                                        <div>
                                            {/* <button className={selectedButton === 'missing' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('missing')}>
                                                <img src={selectedButton === 'missing' ? Exportw : Export} /> <span>Missing</span>
                                            </button>
                                            <button className={selectedButton === 'mvt' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('mvt')}>
                                                <img src={selectedButton === 'mvt' ? Exportw : Export} /> <span>MVT Mismatch</span>
                                            </button> */}
                                            {/* <button className={selectedButton === 'demurrage' ? 'exportbtn me-3 active' : 'exportbtn me-3'} onClick={() => handleButtonClick('demurrage')}>
                                                <img src={selectedButton === 'demurrage' ? Exportw : Export} /> <span>Demurrage</span>
                                            </button> */}

                                        </div>

                                    </div>
                                    <div className="lcontent">
                                        <div className="mb-3 nestedtabs rounded minh">
                                            <div className='d-flex'>
                                                <div>

                                                    <button className="addtruck" variant="primary" onClick={handleAddFlight}>
                                                        <span> <FontAwesomeIcon icon={faPlus} /> Add Flight</span>
                                                    </button>

                                                </div>
                                            </div>
                                        </div>
                                        <div className='ulddown'>
                                            {activeTab === 'Active' && <button > <img title='' src={Arcv} /> Archive </button>} {/* onClick={handleMoveToActArc}*/}
                                            <button onClick={showDownloadModal}><img src={Export} /> Download</button>
                                        </div>
                                        <div className="maindiv">
                                            <div className='trashdonload'>
                                                <Tabs defaultActiveKey={activeTab} onSelect={(tab) => activeTab !== tab ? handleTabChange(tab) : ''} id="station-tabs" className="booking_tab">
                                                    <Tab eventKey="Active" title={<span>Active <Badge className='rabadge'>{totalRows.totalUlds}</Badge></span>} className='moveto'>
                                                        {/* <Loader isLoading={isLoading} /> */}
                                                        {!isLoading && <>
                                                            {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                                                            <div ref={gridRefs.Active} className='bookinggrid' ></div>
                                                        </>
                                                        }
                                                        {/* <div ref={gridRefs.Active} className='bookinggrid' ></div> */}
                                                    </Tab>
                                                    <Tab eventKey="Archived" title={<span>Archived <Badge className='rabadge'>{totalRowsR.totalUlds}</Badge></span>} className='moveto'>
                                                        {/* <Loader isLoading={isLoading} /> */}
                                                        {filterApplied ? <><div className='clear_filter'><Button onClick={resetFilters}>Reset Filters</Button></div></> : <></>}
                                                        {!isLoading && <div ref={gridRefs.Archived} className='bookinggrid' ></div>}
                                                        {/* <div ref={gridRefs.Archived} className='bookinggrid' ></div> */}
                                                    </Tab>
                                                </Tabs>
                                            </div>
                                            {selectedRowData && (
                                                <div className='SecondDiv mt-45'>
                                                    {/* {console.log('55', selectedRowData)} */}
                                                    <button className='close' onClick={handleCloseClick}> <FontAwesomeIcon icon={faXmark} /> </button>
                                                    <div className='girddtals_header'>
                                                        <h3>
                                                            {selectedRowData.uld_number} &nbsp; <span>{selectedRowData.status}</span>
                                                        </h3>
                                                        <div className='d-flex actbtn'>

                                                            <Button variant="light" onClick={browseClick} > <FontAwesomeIcon icon={faPaperclip} /> Attach</Button>

                                                        </div>

                                                    </div>
                                                    <div className='d-flex justify-content-between rabord'>
                                                        <div className='firstbrd'>
                                                            <p>Origin</p>
                                                            <span>{selectedRowData.origin}</span>
                                                        </div>
                                                        <div className='middlebrd'>
                                                            <p>{selectedRowData.flight_date}</p>
                                                            <p><img src={Cargoplane} /></p>
                                                            <p>{selectedRowData.flight_number}</p>
                                                        </div>
                                                        <div className='lastbrd'>
                                                            <p>Destination</p>
                                                            <span>{selectedRowData.destination}</span>
                                                        </div>
                                                    </div>

                                                    <ImageUpload
                                                        ref={imageUploadRef}
                                                        attachable_type={"uld"}
                                                        attachable_id={selectedRowData.uld_number}
                                                        attachments={selectedRowData.attachments}
                                                        onDeleteSuccess={() => loadDetails(selectedRowData.uld_number)}
                                                    />
                                                    <ActivityComments
                                                        commentable_type={"uld"}
                                                        commentable_id={selectedRowData.uld_number}
                                                        allactivities={selectedRowData.activities}
                                                        onReloadDetails={loadDetails}
                                                    />

                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Modal className='raintrac' show={showConfirm} onHide={() => closeConfirm(false)} centered>
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body>
                    <h2>Confirm Delete</h2>
                    <p>If you proceed with the change, all data in this section will be removed.
                        Are you sure you want to continue?</p>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => handleConfirmation(false)}>
                        No
                    </Button>
                    <Button variant="primary" onClick={() => handleConfirmation(true)}>
                        Yes
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default FlightSchedule